import { TreeNode } from "../../Models/Api/TreeList";

export class CategoriesProvider {

    public getCategoryTree(treeNode: TreeNode) {
        const categories = [] as { [codeId: number]: string };

        this.addCategoryTreeToIdTable(treeNode, categories, '');

        return categories;
    }

    private addCategoryTreeToIdTable(treeNode: TreeNode, categoriesFullNames: { [identifier: string]: string }, prefix: string) {
        prefix = prefix ?? "";

        const description = prefix + (prefix.length > 0 ? "; " : "") + treeNode.userFacingDescription;
        categoriesFullNames[treeNode.identifier] = description;

        for (let childNode of treeNode.children) {
            this.addCategoryTreeToIdTable(childNode, categoriesFullNames, description);
        }
    }
}